import { useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await axiosInstance.post('/auth/forgot-password', { email });
      setMessage({ type: 'success', text: 'Falls registriert, wurde eine E-Mail gesendet.' });
    } catch {
      setMessage({ type: 'error', text: 'Fehler beim Senden der E-Mail.' });
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-base-100 shadow-lg rounded">
      <h2 className="text-2xl font-bold mb-4">Passwort vergessen</h2>
      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'} mb-4`}>
          {message.text}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <label className="label">E-Mail</label>
        <input
          type="email"
          className="input input-bordered w-full mb-4"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button className="btn btn-primary w-full">E-Mail senden</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
